var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegisterCustomerDisplayX2B = function SvgRegisterCustomerDisplayX2B(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    x: 40.5,
    y: 41.5,
    stroke: "#B3B3B3",
    rx: 0.5,
    transform: "rotate(-180 40.5 41.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B3B3",
    d: "M7.5 9A2.5 2.5 0 0 1 10 6.5h31A2.5 2.5 0 0 1 43.5 9v5.5h-36zM7.5 42a2.5 2.5 0 0 0 2.5 2.5h31a2.5 2.5 0 0 0 2.5-2.5V14.5h-36z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 2,
    x: 18.5,
    y: 9.5,
    stroke: "#B3B3B3",
    rx: 1
  })));
};
export { SvgRegisterCustomerDisplayX2B as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNDAuNSIgeT0iNDEuNSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjI0IiByeD0iMC41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDQwLjUgNDEuNSkiIHN0cm9rZT0iI0IzQjNCMyIvPgo8cGF0aCBkPSJNNy41IDlDNy41IDcuNjE5MjkgOC42MTkyOSA2LjUgMTAgNi41SDQxQzQyLjM4MDcgNi41IDQzLjUgNy42MTkyOSA0My41IDlWMTQuNUg3LjVWOVoiIHN0cm9rZT0iI0IzQjNCMyIvPgo8cGF0aCBkPSJNNy41IDQyQzcuNSA0My4zODA3IDguNjE5MjkgNDQuNSAxMCA0NC41SDQxQzQyLjM4MDcgNDQuNSA0My41IDQzLjM4MDcgNDMuNSA0MlYxNC41SDcuNVY0MloiIHN0cm9rZT0iI0IzQjNCMyIvPgo8cmVjdCB4PSIxOC41IiB5PSI5LjUiIHdpZHRoPSIxNSIgaGVpZ2h0PSIyIiByeD0iMSIgc3Ryb2tlPSIjQjNCM0IzIi8+Cjwvc3ZnPgo=";